import {
    ISaveCorpusFrontPlankData
} from "../../../../../../../../common-code/interfaces/saveData/ISaveCorpusFrontPlankData";

export const initialFrontPlank = (frontPanel: ISaveCorpusFrontPlankData | null) => {
    let plankPosition = '';
    switch (frontPanel?.initPosition?.y) {
        case '%100':
            plankPosition = 'top';
            break;
        case '%50':
            plankPosition = 'center';
            break;
        case '%0':
            plankPosition = 'bottom';
            break;
    }

    return frontPanel ? {
        width: frontPanel.initSizes.width ?? '',
        position: plankPosition,
        marginX: frontPanel.margin?.x ?? 0,
        marginY: frontPanel.margin?.y ?? 0,
        marginZ: frontPanel.margin?.z ?? 0,
    } : {
        width: '',
        position: '',
        marginX: 0,
        marginY: 0,
        marginZ: 0,
    };
}